import React, { useEffect } from 'react';
import ReactDOM from 'react-dom';
import Routes from './routes';
import MixpanelProvider from './providers/MixpanelProvider';
import { BrowserRouter, useLocation } from 'react-router-dom';
import { createMuiTheme } from '@material-ui/core/styles';
import { CssBaseline } from '@material-ui/core';
import { ThemeProvider } from '@material-ui/styles';
import { useFormContext } from './context/formContext';

const ScrollToTop = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
}

const helvetica = [
  '"Helvetica Neue"',
  'Helvetica',
  'Arial',
  '"Lucida Grande"',
  'sans-serif'
];

const helveticaLight = [
  'HelveticaNeue-Light',
  '"Helvetica Neue Light"'
].concat(helvetica);

const theme = createMuiTheme({
  palette: {
    primary: {
      main: '#1973e8',
    },
    background: {
      default: '#f9f9f9'
    },
    text: {
      primary: '#000000',
      secondary: '#7c7c7c',
      light: '#737373'
    },
  },
  typography: {
    fontFamily: helvetica.join(','),
    body2: {
      fontSize: '1rem',
      lineHeight: 1.5,
      letterSpacing: '0.00938em'
    },
    h1: {
      fontFamily: helveticaLight.join(','),
      fontSize: 24,
      color: '#434343',
      '&.MuiTypography-gutterBottom': {
        marginBottom: '0.6em'
      },
      '@media (min-width: 600px)': {
        fontSize: 48
      }
    },
    h2: {
      fontFamily: helveticaLight.join(','),
      fontSize: 20,
      '&.MuiTypography-gutterBottom': {
        marginBottom: '0.6em'
      },
      '@media (min-width: 600px)': {
        fontSize: 26
      }
    },
    h3: {
      fontFamily: helveticaLight.join(','),
      fontSize: 16,
      lineHeight: '24px',
      color: '#434343',
      '&.MuiTypography-gutterBottom': {
        marginBottom: '0.6em'
      },
      '&.MuiTypography-paragraph': {
        lineHeight: '24px',
        color: '#434343'
      },
      '@media (min-width: 600px)': {
        fontSize: 23,
        '&.MuiTypography-paragraph': {
          lineHeight: '42px'
        }
      }
    },
    subtitle1: {
      fontSize: 18,
      '&.MuiTypography-paragraph': {
        lineHeight: '27px',
        color: '#737373'
      }
    }
  }
});

ReactDOM.render(
  <ThemeProvider theme={theme}>
    <CssBaseline />
    <useFormContext.Provider>
      <MixpanelProvider>
        <BrowserRouter basename='/nest'>
          <ScrollToTop />
          <Routes />
        </BrowserRouter>
      </MixpanelProvider>
    </useFormContext.Provider>
  </ThemeProvider>
  , document.getElementById('root'));

